import React, { useState, useEffect } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useReadContract } from 'wagmi';
import IncentiveProposalModal from '../FormModals/IncentiveProposalModal.tsx';
import SetIncentiveModal from '../FormModals/SetIncentiveModal.tsx';

import incentivesContractABI from '../../contracts/tgetherIncentives.json';

interface IncentiveInfoType {
    structure: string;
    communityFee: number;
    contractRecieveAddress: string;
    isSet: boolean;
}

function IncentiveParams({ community, isOwner }: { community: string, isOwner: boolean }) {
    const [incentiveInfo, setIncentiveInfo] = useState<IncentiveInfoType | null>(null);
    const [showIncentiveProposalModal, setShowIncentiveProposalModal] = useState(false);
    const [showSetIncentiveModal, setShowSetIncentiveModal] = useState(false);

    const incentivesContractAddress = process.env.REACT_APP_INCENTIVES_CONTRACT_ADDRESS as `0x${string}`;

    // Fetch incentive info
    const { data: incentiveData, isSuccess: incentiveSuccess } = useReadContract({
        address: incentivesContractAddress,
        abi: incentivesContractABI.abi,
        functionName: 'getIncentiveParamsExist',
        args: [community],
    });

    const { data: incentiveDetails, isSuccess: incentiveDetailsSuccess } = useReadContract({
        address: incentivesContractAddress,
        abi: incentivesContractABI.abi,
        functionName: 'getCommunityFeeInfo',
        args: [community],
    });

    const { data: structureData, isSuccess: structureSuccess } = useReadContract({
        address: incentivesContractAddress,
        abi: incentivesContractABI.abi,
        functionName: 'getInctiveStructure',
        args: [community],
    });

    useEffect(() => {
        if (incentiveSuccess && incentiveDetailsSuccess && structureSuccess && incentiveData && incentiveDetails && structureData !== undefined) {
            // Map the enum value to a user-friendly string
            const structureLabel = structureData === '0' ? 'Equal' : 'Consensus Aligned';

            setIncentiveInfo({
                structure: structureLabel,
                communityFee: Number(incentiveDetails[0]),
                contractRecieveAddress: incentiveDetails[1],
                isSet: Boolean(incentiveData),
            });
        }
    }, [incentiveSuccess, incentiveDetailsSuccess, structureSuccess, incentiveData, incentiveDetails, structureData]);

    return (
        <Card style={{
            margin: '20px auto',
            padding: '20px',
            maxWidth: '600px',
            backgroundColor: '#1f1f1f',
            borderRadius: '8px',
            color: '#ffffff',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
        }}>
            <h5 style={{
                fontWeight: 'bold',
                marginBottom: '15px',
                backgroundColor: '#2a2a2a',
                color: '#ffffff',
                padding: '10px',
                borderRadius: '4px',
                textAlign: 'center'
            }}>
                Incentive Parameters
            </h5>
            {incentiveInfo && incentiveInfo.isSet ? (
                <div style={{ lineHeight: '1.8' }}>
                    <Card.Text><strong>Incentive Structure:</strong> <span className="badge bg-info">{incentiveInfo.structure}</span></Card.Text>
                    <Card.Text><strong>Community Fee:</strong> <span className="badge bg-success">{incentiveInfo.communityFee}%</span></Card.Text>
                    <Card.Text><strong>Contract Receive Address:</strong> <span style={{ color: '#f0ad4e' }}>{incentiveInfo.contractRecieveAddress}</span></Card.Text>
                </div>
            ) : (
                <Card.Text>Incentive parameters for this community have yet to be set.</Card.Text>
            )}
            {isOwner && !incentiveInfo?.isSet && (
                <Button variant="info" style={{ marginTop: '10px', width: '100%' }} onClick={() => setShowSetIncentiveModal(true)}>
                    Set Incentive Parameters
                </Button>
            )}
            <Button
                variant="info"
                style={{ marginTop: '10px', width: '100%' }}
                onClick={() => setShowIncentiveProposalModal(true)}
            >
                Propose New Incentive Parameters
            </Button>
            <IncentiveProposalModal
                show={showIncentiveProposalModal}
                setShow={() => setShowIncentiveProposalModal(false)}
                communityName={community}
            />
            <SetIncentiveModal
                show={showSetIncentiveModal}
                setShow={() => setShowSetIncentiveModal(false)}
                communityName={community}
            />
        </Card>
    );
}

export default IncentiveParams;
